import React from "react";

import {
  Box,
} from "@material-ui/core"

// Styles
import { ensureApp, useClasses } from "../globals"

export const Logo = () => {
  const classes = useClasses()
  const app = ensureApp();

  return (
    <Box className={classes._PaddingDouble}>
      <img
        alt="SimGate Studio Login"
        src={window.location.origin?.indexOf("managementconcepts") >= 0 ? "https://cdn.regis-co.com/managementconcepts/MC LOGO_2021_small.png" : `${window.location.origin}/assets/logo3-dark.svg`}
        style={{
          maxHeight: "100px",
          minWidth: "330px",
          objectFit: "contain",
        }}
        className={classes._Width100Percent}
      />
    </Box>
  )
}